/**
 * 全局的 getters 映射
 */
const getters = {}
export default getters
